module.exports = __webpack_public_path__ + "img/howto-3.205cf9a7.png";